import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru A - sedan widok lewy
 */
export const AreaA_Sedan_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="101"
      height="158"
      viewBox="0 0 101 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_sedan_left"
          x="0"
          y="0"
          width="101"
          height="158"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_a_sedan_left)">
        <path
          d="M76.3643 7.7793C78.5125 15.1981 80.6792 23.6538 82.8027 33.1475C85.3082 44.3525 88.2296 59.8077 91.082 74.9023L91.0928 74.9639C91.3182 76.1567 91.5433 77.3475 91.7676 78.5332C94.5484 93.2356 97.2443 107.328 99.3438 116.051L97.6104 118.362C96.613 116.829 95.5798 115.242 94.5215 113.621L94.5186 113.617L94.0586 112.913C92.8161 111.01 90.4378 110.197 88.29 110.939C86.1427 111.682 84.7756 113.79 84.9736 116.054C85.6233 123.472 86.4465 134.553 87.4307 147.796L87.4316 147.8C87.586 149.877 87.7431 152.008 87.9053 154.186C82.6736 152.487 76.3297 151.532 69.4316 151.078C59.7126 150.438 48.3184 150.759 36.2188 151.748C20.9757 152.995 11.1362 154.314 1.71875 155.875C1.58619 149.512 1.44862 143.342 1.31641 137.446V137.444L1.02148 124.043C15.7961 123.857 25.967 122.569 40.8418 115.4C60.4289 105.965 74.4281 85.0753 74.0752 61.2773C73.9445 52.4955 72.4212 45.342 69.5791 38.3584C69.7506 37.9845 69.9165 37.624 70.0771 37.2754L70.0791 37.2695L70.0811 37.2666L70.0801 37.2656C70.3039 36.78 70.5188 36.3169 70.7207 35.874C71.2207 34.7774 71.8114 33.4715 72.0859 32.5117L72.0879 32.5039L72.0869 32.5029C72.9692 29.4044 73.7114 26.5206 74.3154 23.792C75.6286 17.8597 76.2746 12.7218 76.3643 7.7793Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
